import React, { useEffect, useState } from 'react';
import { Schedule } from '../types';
import { getLessons } from '../api/api';
import { useNavigate } from 'react-router-dom';


const initialSchedule: Schedule = {
  ראשון: [],
  שני: [],
  שלישי: [],
  רביעי: [],
  חמישי: [],
};

const hours = ["09:00", "10:00", "11:00", "12:00", "13:00", "14:00"];

const colors = [
  'rgba(255, 0, 0, 0.3)',   // Red
  'rgba(255, 127, 0, 0.3)', // Orange
  'rgba(255, 255, 0, 0.3)', // Yellow
  'rgba(0, 255, 0, 0.3)',   // Green
  'rgba(0, 0, 255, 0.3)',   // Blue
  'rgba(75, 0, 130, 0.3)',  // Indigo
  'rgba(148, 0, 211, 0.3)'  // Violet
];

const SchedulePage: React.FC = () => {
  const [schedule, setSchedule] = useState<Schedule>(initialSchedule);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchLessons = async () => {
        const lessons = await getLessons();
        const daysOfWeek = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי'];

        const schedule = daysOfWeek.reduce((acc:any, day) => {
            acc[day] = lessons.filter(lesson => lesson.day === day);
            return acc;
        }, {});

        setSchedule(schedule);
    };

    try {
      fetchLessons();
      
    } catch (error) {
      console.log(error);
      
    }
}, []);

  return (
    <div className='page'>
    <h1>מערכת שבועית</h1>
    <div className='description'>
    להרשמה לחצו על ההרצאה שמעניינת אתכם!
    <br/>
בתום הרישום תקבלו מייל אישור ולאחר מכן נתקשר אליכם עם כל הפרטים על ההרצאה.

 
    </div>
    <div className="schedule">
        {Object.keys(schedule).map((day) => (
            <div className="day-container" key={day}>
                <h2>{day}</h2>
                    {hours.map((hour, index) => {
                        const lesson = schedule[day].find(lesson => lesson.time === hour);
                        const backgroundColor = lesson ? colors[index % colors.length] : 'transparent'; // Use rainbow colors for lessons
                        return (
                          <a href={lesson?.link} target="_blank" rel="noopener noreferrer">

                            <div 
                                key={hour} 
                                className="hour-slot" 
                                style={{ backgroundColor,  }}
                                >
                                <strong>{hour}: </strong>
                                {lesson ? lesson.name : "פנוי"}
                            </div>
                              </a>
                        );
                    })}
            </div>
        ))}
    </div>
</div>
  );
};

export default SchedulePage;